import { Component } from '@angular/core';

@Component({
  selector: 'mt-features-section',
  templateUrl: './features-section.component.html',
  styleUrls: ['./features-section.component.scss', '../home.component.scss'],
})
export class FeaturesSectionComponent {}
